import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setFormJson,
  setLoading,
  setProducts,
  setIsFetchingFormJson,
} from "../slices/stepperDynamicFormSlice";
import eligibilityCheckServices from "../../api/service/eligibilityCheckService";
import type { RootState } from "../store";

/** Explicit arg type so dispatch(getFormJson({ trackingId })) is typed (inference can drop fields). */
export type GetFormJsonArg = {
  product?: string;
  loaderShow?: boolean;
  callBack?: (type: string) => void;
  trackingId?: string;
};

export const getFormJson = createAsyncThunk<
  unknown,
  GetFormJsonArg,
  { state: RootState }
>("stepper/getFormJson", async (
  { product, loaderShow = true, callBack, trackingId },
  { dispatch, getState }
) => {
    const state = getState();
    const { selectedProduct, isFetchingFormJson } = state.stepper;

    // Guard against duplicate in-flight requests (e.g., React StrictMode double effects)
    if (isFetchingFormJson) {
      return;
    }
    dispatch(setIsFetchingFormJson(true));
    const authProfile = state?.auth?.userProfile;

    if (loaderShow) {
      dispatch(setLoading(true));
    }
    try {
      const payload = {
        productCode: product || selectedProduct || "SLI",
        id: authProfile?.id,
        trackingId: trackingId,
      };

      const res = await eligibilityCheckServices.getForm(payload);
      if (res.status === 200) {
        const response: any = res.data.data;
        response.horizontalSteps?.forEach((hStep: any) => {
          hStep?.verticalSteps?.forEach((vStep: any) => {
            if (Array.isArray(vStep?.fields)) {
              vStep.fields.sort(
                (a: any, b: any) => Number(a?.fieldOrder) - Number(b?.fieldOrder)
              );
            }
          });
        });
        const formJson: any = response.horizontalSteps.filter(
          (elem: any) => elem?.stepKey == "eligibility_check"
        );
        formJson?.[0]?.verticalSteps.push({
          id: 4,
          stepLabel: "Confirmation on Eligibility",
          stepOrder: 4,
          fields: [],
        });

        dispatch(setFormJson(response));

        if (loaderShow) {
          dispatch(setLoading(false));
        }
        if (callBack) {
          callBack("form");
        }
        return res.data;
      } else {
        throw new Error("Failed to fetch form JSON");
      }
    } catch (error: any) {
      console.error("Error fetching form JSON:", error);
      dispatch(setLoading(false));
    } finally {
      dispatch(setIsFetchingFormJson(false));
    }
  }
);

export const fetchProducts = () => async (dispatch: any) => {
  try {
    const res = await eligibilityCheckServices.getProducts();
    if (res.data && Array.isArray(res.data.data)) {
      dispatch(setProducts(res.data.data));
    }
  } catch (error) {
    // Optionally handle error
    dispatch(setProducts([]));
  }
};
